document.addEventListener('DOMContentLoaded', function () {

  var HEADBOARD_PRICES = {
  '2ft6': '£20.00',
  '3ft': '£20.00',
  '4ft': '£35.00',
  '4ft6': '£35.00',
  '5ft': '35.00',
  '6ft': '£50.00'
};

  function cleanText(value) {
    return String(value || '').toLowerCase().replace(/-/g, ' ').replace(/\s+/g, ' ').trim();
  }

  function is54FloorStanding(text) {
    var s = cleanText(text);
    return s.includes('floor standing') && s.includes('54');
  }

  function getSizeKey(text) {
    var s = cleanText(text);
    if (s.includes('small single') || s.includes('2ft6')) return '2ft6';
    if ((s.includes('single') || s.includes('3ft')) && !s.includes('small')) return '3ft';
    if (s.includes('small double') || s.includes('4ft')) return '4ft';
    if ((s.includes('double') || s.includes('4ft6')) && !s.includes('small')) return '4ft6';
    if ((s.includes('king') || s.includes('5ft')) && !s.includes('super')) return '5ft';
    if (s.includes('super king') || s.includes('6ft')) return '6ft';
    return '';
  }

  function getSelectedSize() {
    var selects = document.querySelectorAll('variant-picker select');
    for (var i = 0; i < selects.length; i++) {
      var sel = selects[i];
      var name = cleanText(sel.name || '');
      if (name.includes('size')) {
        var selectedText = sel.options[sel.selectedIndex] ? sel.options[sel.selectedIndex].text : '';
        return getSizeKey(selectedText);
      }
    }

    var checkedRadios = document.querySelectorAll('variant-picker fieldset input[type="radio"]:checked');
    for (var j = 0; j < checkedRadios.length; j++) {
      var input = checkedRadios[j];
      var fieldset = input.closest('fieldset');
      if (fieldset) {
        var legend = fieldset.querySelector('legend');
        if (legend && cleanText(legend.textContent).includes('size')) {
          return getSizeKey(input.value);
        }
      }
    }

    return '';
  }

  function updateHeadboardPrice() {
    var headboardSelects = document.querySelectorAll('select[data-headboard-option]');
    if (!headboardSelects.length) return;

    var sizeKey = getSelectedSize();
    var price = HEADBOARD_PRICES[sizeKey] || '';

    for (var i = 0; i < headboardSelects.length; i++) {
      var sel = headboardSelects[i];
      for (var k = 0; k < sel.options.length; k++) {
        var opt = sel.options[k];
        var baseText = opt.getAttribute('data-base-text');
        if (!baseText) {
          baseText = opt.textContent.trim();
          opt.setAttribute('data-base-text', baseText);
        }

        if (is54FloorStanding(opt.value)) {
          opt.textContent = price ? baseText + ' +' + price : baseText;
        } else {
          opt.textContent = baseText;
        }
      }
    }

    var headboardFieldsets = document.querySelectorAll('fieldset[data-headboard-option]');
    for (var m = 0; m < headboardFieldsets.length; m++) {
      var fs = headboardFieldsets[m];
      var labels = fs.querySelectorAll('.variant-option__button-label');
      for (var n = 0; n < labels.length; n++) {
        var lbl = labels[n];
        var radio = lbl.querySelector('input[type="radio"]');
        var textEl = lbl.querySelector('.variant-option__button-label__text');
        if (!radio || !textEl) continue;

        var baseName = textEl.getAttribute('data-base-text');
        if (!baseName) {
          baseName = textEl.textContent.trim();
          textEl.setAttribute('data-base-text', baseName);
        }

        if (is54FloorStanding(radio.value)) {
          textEl.textContent = price ? baseName + ' (+' + price + ')' : baseName;
        } else {
          textEl.textContent = baseName;
        }
      }
    }
  }

  updateHeadboardPrice();

  setInterval(updateHeadboardPrice, 1000);

  var picker = document.querySelector('variant-picker');
  if (picker) {
    picker.addEventListener('change', function () {
      setTimeout(updateHeadboardPrice, 500);
    });
  }
});
